// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__X51zn {
  width: -web-kit-fill-available; }
  .styles_container__X51zn.styles_fullScreen__jr1bO {
    height: 100vh;
    overflow: scroll; }
  .styles_container__X51zn .styles_footer__EM93s {
    max-width: 100%; }
    .styles_container__X51zn .styles_footer__EM93s button {
      margin-right: 3rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/components/form/Form/styles.module.scss"],"names":[],"mappings":"AACA;EACI,8BAA8B,EAAA;EADlC;IAGQ,aAAa;IACb,gBAAgB,EAAA;EAJxB;IAYS,eAAe,EAAA;IAZxB;MAUY,kBAAkB,EAAA","sourcesContent":["\n.container {\n    width: -web-kit-fill-available;\n    &.fullScreen {\n        height: 100vh;\n        overflow: scroll;\n    }\n\n\n    .footer {\n         & button {\n            margin-right: 3rem;\n         }\n         max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__X51zn`,
	"fullScreen": `styles_fullScreen__jr1bO`,
	"footer": `styles_footer__EM93s`
};
export default ___CSS_LOADER_EXPORT___;
